import React from 'react';
import SimpleReportNotice from '../../PageComponents/SimpleReportNotice';

/**
 * DeerFlow 消息处理器工具函数
 * 处理消息列表中的报告通知，转换为对应的组件
 */
const processDeerFlowMessages = (messages, sessionId, deerFlowChatProps, style) => {
    // 处理消息内容中的报告通知卡片
    const processedMessages = messages.map((msg, index) => {
        // 为所有包含报告通知的AI消息显示报告卡片
        const shouldShowReport =
            msg.content &&
            typeof msg.content === 'string' &&
            msg.content.includes('data-type="report-notice"') &&
            (msg.role === 'ai' || msg.role === 'assistant');

        if (shouldShowReport) {
            // 为报告通知卡片添加组件替换
            // 优先使用消息中的threadId，如果没有则使用当前会话ID
            const threadId = msg.threadId || msg.session_id || sessionId;
            const reportId = msg.reportId || msg.question?.reportId;

            // 从内容中解析uniqueReportId
            let uniqueReportId = null;
            if (typeof msg.content === 'string') {
                const match = msg.content.match(/data-unique-report-id="([^"]+)"/);
                if (match && match[1]) {
                    uniqueReportId = match[1];
                }
            }
            // 如果在消息中没有找到，查看msg.question中是否有
            if (!uniqueReportId && msg.question && msg.question.uniqueReportId) {
                uniqueReportId = msg.question.uniqueReportId;
            }

            // 优先使用从内容中解析的uniqueReportId，然后是后端返回的task_id，最后是reportId
            const finalReportId = msg.task_id || reportId;
            // 优先使用从内容中解析的uniqueReportId，确保使用正确的报告ID
            const finalUniqueReportId = uniqueReportId || msg.task_id || finalReportId;

            // 使用缓存避免重复创建组件
            const cacheKey = `${finalUniqueReportId}_${sessionId}`;
            if (!deerFlowChatProps.reportComponentsCache.current[cacheKey]) {
                deerFlowChatProps.reportComponentsCache.current[cacheKey] = true;
            }

            // 检查所有可能的ID是否正在生成（提前计算，供多处使用）
            const possibleIds = [finalUniqueReportId, finalReportId, msg.task_id, uniqueReportId].filter(Boolean);
            const isGenerating = possibleIds.some((id) => deerFlowChatProps.generatingReports[id] === true);

            // 🔥 修复：过滤掉不应该传递给DOM的属性
            const {
                requestId,
                temId,
                apart,
                question,
                session_id,
                reportId: msgReportId,
                task_id,
                handler,
                content_type,
                file_json,
                references,
                multimodal_reference,
                recommend_course_result,
                multimodal_learning_result,
                ai_evaluation,
                component,
                card_result,
                processing,
                web_result,
                retrieval_result,
                course_result,
                isHidden,
                _id,
                ...cleanMsg
            } = msg;
            // debug: log when replacing a report-notice string with the React component
            return {
                ...cleanMsg,
                content: (
                    <SimpleReportNotice
                        key={`report-notice-${finalUniqueReportId}`}
                        threadId={threadId}
                        reportId={finalReportId}
                        uniqueReportId={finalUniqueReportId}
                        title={(() => {
                            // 如果是正在生成的报告，始终显示"研究报告"
                            if (isGenerating) {
                                return '研究报告';
                            }
                            // 如果消息状态是loading，也显示"研究报告"
                            if (question?.status === 'loading') {
                                return '研究报告';
                            }

                            return deerFlowChatProps.getReportTitle(cleanMsg, possibleIds, isGenerating);
                        })()}
                        initiallyOpened={deerFlowChatProps.sidebarOpen && (finalUniqueReportId === deerFlowChatProps.activeReportId || finalReportId === deerFlowChatProps.activeReportId)}
                        stateUpdaters={deerFlowChatProps.reportNoticeStateUpdaters.current}
                        onSidebarOpen={deerFlowChatProps.handleSidebarOpenLocal}
                        onSidebarClose={deerFlowChatProps.handleSidebarClose}
                        activeReportCardId={deerFlowChatProps.activeReportCardId} // 传递当前活跃的卡片ID
                        isGenerating={isGenerating} // 使用generatingReports判断是否显示生成状态
                        status={deerFlowChatProps.getReportNoticeStatus(msg, possibleIds)} // 传递状态
                        themeColor={style.themeColor} // 传递主题颜色
                    />
                )
            };
        }
        return msg;
    });

    return processedMessages;
};

export default processDeerFlowMessages;
